import axiosInstance from './axiosInstance';

export const getMyStoreApi    = ()       => axiosInstance.get('/store/me/profile');
export const updateMyStoreApi = (data)   => axiosInstance.put('/store/me/profile', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const getStoreByIdApi  = (id)     => axiosInstance.get(`/store/${id}`);
export const getStoresApi     = (params) => axiosInstance.get('/store', { params });
